"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _ProductList = _interopRequireDefault(require("./ProductList"));

var _Terms = require("self-service-api/constants/Terms");

var _SuiteTileCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteTileCTAsContainer"));

var _SuiteViewAllFeatures = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteViewAllFeatures"));

var _SuiteEditionIdentifiersMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionIdentifiersMap"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _SpinnerLoadWrapper = _interopRequireDefault(require("../../components/loading/SpinnerLoadWrapper"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _Hubs = require("self-service-api/constants/Hubs");

var _PromotionSelectors2 = require("../../selectors/PromotionSelectors");

var _SuiteCovidPromoBanner = _interopRequireDefault(require("./SuiteCovidPromoBanner"));

var _Editions = require("self-service-api/constants/Editions");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    margin-left: 0;\n    margin-top: 15px;\n    height: auto;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-bottom: 10px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: 10px;\n  width: 200px;\n  text-align: center;\n  button,\n  a {\n    width: 100%;\n    line-height: 23px;\n  }\n  ", "\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 27px;\n  text-decoration: line-through;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 18px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 12px;\n  color: ", ";\n  margin-bottom: 5px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 36px;\n  color: ", ";\n  margin-right: 15px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 16px;\n  font-weight: normal;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 26px;\n  margin-bottom: 10px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 25px 20px;\n    > div {\n      flex-direction: column;\n      margin-bottom: 25px;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    height: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  max-width: 1100px;\n  border-radius: 0;\n  border: 1px solid ", ";\n  height: 337px;\n  background: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 32px;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Tile = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Tile",
  componentId: "sc-1aik77g-0"
})(_templateObject(), _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints.default.tabletPortrait(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));

var TileContentContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__TileContentContainer",
  componentId: "sc-1aik77g-1"
})(_templateObject4(), function (props) {
  return props.hasBanner ? '24px 60px 60px' : '60px';
});

var Title = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Title",
  componentId: "sc-1aik77g-2"
})(_templateObject5());

var SubTitle = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__SubTitle",
  componentId: "sc-1aik77g-3"
})(_templateObject6());

var Price = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__Price",
  componentId: "sc-1aik77g-4"
})(_templateObject7(), _colors.OZ);

var PriceHeader = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__PriceHeader",
  componentId: "sc-1aik77g-5"
})(_templateObject8(), _colors.EERIE);

var PerMonth = _styledComponents.default.span.withConfig({
  displayName: "GrowthSuiteTile__PerMonth",
  componentId: "sc-1aik77g-6"
})(_templateObject9());

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "GrowthSuiteTile__CrossedOutPrice",
  componentId: "sc-1aik77g-7"
})(_templateObject10(), _colors.PANTERA);

var StyledCTAsContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteTile__StyledCTAsContainer",
  componentId: "sc-1aik77g-8"
})(_templateObject11(), _responsiveBreakpoints.default.tablet(_templateObject12()), _responsiveBreakpoints.default.phone(_templateObject13()));

var GrowthSuiteTile = function GrowthSuiteTile(_ref) {
  var edition = _ref.edition,
      currencyCode = _ref.currencyCode,
      growthSuiteDiscount = _ref.growthSuiteDiscount,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible,
      getGrowthSuiteAvailableTerms = _ref.getGrowthSuiteAvailableTerms,
      calculateBundlePrice = _ref.calculateBundlePrice;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var shouldApplyCovidPromo = edition === _Editions.STARTER && isCovidGrowthSuitePromoEligible;
  var availableTerms = getGrowthSuiteAvailableTerms(shouldApplyCovidPromo);
  var defaultTerm = (0, _itemConfigUtils.getApplicableTerm)(_Terms.MONTHLY, availableTerms[edition]);
  var pricingInfo;
  var originalDiscountedPrice;

  if (hasPricingAndPurchasingSucceeded) {
    var params = {
      bundleSelections: {
        marketingPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_MARKETING],
        salesPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_SALES],
        servicePlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_SERVICE]
      },
      term: defaultTerm,
      isGrowthSuite: true
    };
    pricingInfo = calculateBundlePrice((0, _extends2.default)({}, params, {
      isCovidPromo: shouldApplyCovidPromo
    })); // To get the _original_ discounted price to compare with Covid Promo price

    originalDiscountedPrice = calculateBundlePrice(params).monthly.calculatedPrice;
  }

  return _react.default.createElement(Tile, {
    "data-selenium-id": (0, _SuiteEditionIdentifiersMap.default)(isInMCBeta)[edition] + "-merch-card"
  }, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded
  }, shouldApplyCovidPromo && _react.default.createElement(_SuiteCovidPromoBanner.default, {
    toPrice: pricingInfo && pricingInfo.monthly.calculatedPrice,
    fromPrice: originalDiscountedPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(TileContentContainer, {
    hasBanner: shouldApplyCovidPromo
  }, _react.default.createElement(_UIFlex.default, null, _react.default.createElement(_UIBox.default, {
    grow: 1
  }, _react.default.createElement(Title, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricingPage.pages.growthSuite.title." + edition + "_html"
  })), // Don't render description if the promo banner exists, as there is a disagreement in discount math between the banner copy and subtitle copy
  !shouldApplyCovidPromo && _react.default.createElement(SubTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.discount." + edition,
    options: {
      percent: growthSuiteDiscount
    }
  })), _react.default.createElement(PriceHeader, {
    className: "m-top-6"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.startsAt"
  })), _react.default.createElement(_UIFlex.default, {
    className: "m-bottom-6",
    align: "baseline"
  }, _react.default.createElement(Price, {
    "data-selenium-id": (0, _SuiteEditionIdentifiersMap.default)(isInMCBeta)[edition] + "-highlighted-price-per-month"
  }, _react.default.createElement(_PriceDisplay.default, {
    price: pricingInfo && pricingInfo.monthly.calculatedPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(PerMonth, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  }))), _react.default.createElement(CrossedOutPrice, {
    price: shouldApplyCovidPromo ? originalDiscountedPrice : pricingInfo && pricingInfo.monthly.fullPrice,
    currencyCode: currencyCode
  })), _react.default.createElement("div", {
    style: {
      fontWeight: 600
    }
  }, _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.includes"
  })), _react.default.createElement(_ProductList.default, {
    edition: edition
  }))), _react.default.createElement(StyledCTAsContainer, null, _react.default.createElement(_SuiteTileCTAsContainer.default, {
    edition: edition,
    isCovidPromo: isCovidGrowthSuitePromoEligible
  }), _react.default.createElement("div", {
    className: "m-top-4"
  }, _react.default.createElement(_SuiteViewAllFeatures.default, {
    className: "m-top-4",
    edition: edition,
    currencyCode: currencyCode
  })))))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getGrowthSuiteAvailableTerms: function getGrowthSuiteAvailableTerms(isCovidPromo) {
      return (0, _PromotionSelectors2.growthSuiteAvailableTermsSelector)(state, isCovidPromo);
    },
    growthSuiteDiscount: (0, _PromotionSelectors.growthSuiteDiscountSelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    calculateBundlePrice: (0, _PricingSelectors.getCalculateBundlePriceSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteTile);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuiteTile.js
// module id = 855
// module chunks = 5 6